import { Controller } from "@hotwired/stimulus"
import { openAxeptioPreferences } from "../lib/axeptio"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    openAxeptioPreferences().catch(() => {})
  }
}
